import { styled } from '@creditas/stylitas'
import { Typography } from '@creditas/typography'
import {
  ButtonSecondary,
  styled as newStyled,
  selectTheme,
  css,
} from '@creditas-ui/react'
import { PulsingCircle } from 'shared/ui/PulsingCircle'

export const Aside = styled.aside`
  width: 35vw;
  background-color: ${({ theme }) => theme.bColorNeutral10};
  height: 100vh;
  padding: 50px 0;
  overflow-y: auto;

  h4 {
    padding: 0 30px;
  }
`

export const Content = styled.div`
  padding: 50px 16px 50px 120px;
  width: 65vw;
  height: 100vh;
  overflow-y: auto;
`

export const View = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100% - 94px);
`

export const Name = styled(Typography)`
  color: ${({ theme }) => theme.bColorNeutral90};
  font-weight: 300;

  span {
    font-weight: 700;
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.bColorNeutral90};
  margin-bottom: 40px;
  font-weight: 300;
`

export const Box = styled.section`
  margin: 50px 0;
  position: relative;
`

export const ProposalWrapper = styled(Box)`
  padding-right: 150px;
`

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 32px;
`

export const Label = styled(Typography)`
  color: ${({ theme }) => theme.bColorNeutral60};
  font-size: 16px;
  font-weight: 400;
`

export const Value = styled(Typography)`
  color: ${({ theme }) => theme.bColorNeutral90};
  font-size: 16px;
  font-weight: 600;
`

export const FeedItem = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 400;
  margin-bottom: 40px;
`

export const FeedItemContent = styled.div`
  padding-right: 10px;
`

export const FeedItemTitle = styled.p`
  color: ${({ theme }) => theme.bColorNeutral90};
  font-size: 16px;
  line-height: 24px;
  font-weight: bold;
`

export const FeedItemSubtitle = newStyled.p`
  color: ${selectTheme('colors.neutral.90')};
  font-size: 16px;
  line-height: 24px;
  margin-top: 12px;
  a {
    text-decoration: none;
    color: ${selectTheme('colors.primary.60')};
  }
`

export const FeedItemTime = styled.p`
  color: ${({ theme }) => theme.bColorNeutral90};
  font-size: 14px;
  line-height: 20px;
  margin-top: 6px;
`

export const FeedItemRejectionReason = styled.p`
  color: ${({ theme }) => theme.bColorNeutral60};
  font-size: 16px;
  line-height: 24px;
  padding-top: 12px;
`

export const FeedItemPulsingCircle = styled(PulsingCircle)`
  margin-right: 15px;
`

export const StepCard = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${props =>
    props.current ? ({ theme }) => theme.bColorNeutral15 : 'none'};
  padding: 15px 25px;

  svg {
    margin-right: 10px;
  }
`

export const StepContent = styled.div`
  width: 100%;
`

export const StepTitle = styled.p`
  color: ${props =>
    props.hasStarted
      ? ({ theme }) => theme.bColorNeutral90
      : ({ theme }) => theme.bColorNeutral60};
  font-size: 18px;
  line-height: 24px;
  margin-top: ${props => (props.hasStarted ? '0px' : '5px')};
`

export const StepSubtitle = styled.p`
  color: ${({ theme }) => theme.bColorNeutral60};
  font-size: 14px;
  line-height: 20px;
  max-width: 70%;
`

export const ErrorContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

export const FeedAction = styled(ButtonSecondary)`
  padding: 0;
  margin-top: 28px;
`

export const CustomScroll = newStyled.div`
  background-color: ${selectTheme('colors.neutral.10')};
  border-radius: 9px;
  position: relative;
  z-index: 2;
`

export const showFade = ({ show }) =>
  show &&
  css`
    display: block;
  `

export const Fade = newStyled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 150px;
  background: linear-gradient(
    360deg,
    #ffffff 30%,
    rgba(255, 255, 255, 0) 134.17%
  );
  opacity: ${({ show }) => (show ? 1 : 0)};
  z-index: 1;
  display: none;
  ${showFade}
`

export const WrapperInspectionLink = styled.div`
  align-items: center;
  display: flex;
  padding: 4px;
  margin-top: 19px;
`

export const InspectionLink = styled(Typography)`
  color: ${({ theme }) => theme.bColorPrimary80};
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  vertical-align: middle;
`
